import { AfterViewInit, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { TaskService } from '../../../../services';
import {
  JobScreenVehicleInformationTask,
  JobScreenVehicleInformationVehicle,
} from '../../../../interfaces/screen-specific/job-screen';
import { OrganisationTypeEnum } from '../../../../enums/organisation-types';

@Component({
  selector: 'job-screen-vehicle-information',
  templateUrl: './job-screen-vehicle-information.component.html',
  styleUrls: ['./job-screen-vehicle-information.component.scss'],
})
export class JobScreenVehicleInformationComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() organisationTypeId: number;
  @Input() taskId: number;

  selectedTask: JobScreenVehicleInformationTask = null;
  vehicle: JobScreenVehicleInformationVehicle;
  loadingTask: boolean;
  editVehicleVisible: boolean = false;

  protected readonly OrganisationTypeEnum = OrganisationTypeEnum;

  constructor(public taskService: TaskService) {}

  ngOnInit(): void {}

  async ngAfterViewInit() {}

  async ngOnChanges(changes: SimpleChanges) {
    if (changes.taskId) {
      this.loadVehicle();
    }
  }

  loadVehicle() {
    this.loadingTask = true;
    this.taskService
      .getForComponent(this.taskId, 'job-screen-vehicle-information')
      .then((task: JobScreenVehicleInformationTask) => {
        this.selectedTask = task;
        this.loadingTask = false;
        this.vehicle = task.vehicle;
      });
  }

  onVehicleUpdated() {
    this.loadVehicle();
    this.editVehicleVisible = false;
  }
}
